import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { stylesSortableItem } from './styles';
/**
 * @since 1.3.0
 * @status stable
 *
 * @tagname kemet-sortable-item
 * @summary An item in a sortable list.
 *
 * @prop {boolean} ghost - Automatically set to true when an item is dragged to a new spot.
 */
let KemetSortableItem = class KemetSortableItem extends LitElement {
    firstUpdated() {
        this.draggable = true;
    }
    render() {
        return html `<slot></slot>`;
    }
};
KemetSortableItem.styles = [stylesSortableItem];
__decorate([
    property({ type: Boolean, reflect: true })
], KemetSortableItem.prototype, "ghost", void 0);
KemetSortableItem = __decorate([
    customElement('kemet-sortable-item')
], KemetSortableItem);
export default KemetSortableItem;
//# sourceMappingURL=kemet-sortable-item.js.map